"use strict";
import "lodash";
import { svc_fetchAll, svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { svc_getTerminals } from "@/services/staff";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

const endpointBasePrefix = "bulk-edit";

const Model = {
    namespace: "m_MenuBulkEdit",
    state: {
        items: [],
    },
    reducers: {
        handleFetchAll(state, { payload: { items } }) {
            return { ...state, items };
        },
    },
    effects: {
        *fetchAll({ payload }, { call, put }) {
            const items = yield call(svc_search, endpointBasePrefix, payload);
            if (!showServerResponse(items, true)) return;

            _.forEach(items.result, function (row) {
                row.key = row.id;
				row = convertISODateTimeToString(row, ["created_at", "updated_at"], config.dateTimeFormat);
            });

            yield put({
                type: "handleFetchAll",
                payload: { items },
            });

            return items;
        },
        *publishAll({ payload }, { call, put }) {
            if (payload && payload.brand_id) {
                payload = _.omit(payload, ["id", "key"]);
                const response = yield call(svc_addOne, `${endpointBasePrefix}/publish`, payload);
                showServerResponse(response);
                return response;
            }
        },
        *editOne({ payload }, { call, put }) {
            if (payload && payload.id) {
                const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
                showServerResponse(response);
                return response;
            }
        },
        *deleteOne({ payload }, { call, put }) {
            if (payload && payload.id && payload.type) {
                payload = _.omit(payload, ["key"]);
                const response = yield call(svc_deleteOne, `${endpointBasePrefix}/${payload.type}`, payload, "id");
                showServerResponse(response);
                return response;
            }
        },
        *priceAdjust({ payload }, { call, put }) {
            const response = yield call(svc_addOne, `${endpointBasePrefix}/price-adjust`, payload);
            showServerResponse(response);
            return response;
        },
        *batchUpdate({ payload }, { call, put }) {
            const response = yield call(svc_addOne, `${endpointBasePrefix}/batch-update`, payload);
            showServerResponse(response);
            return response;
        },
    },
    subscriptions: {},
};

export default Model;
